import React from 'react';
import { cn } from '../lib/utils';

const SIZES = {
  sm: { box: 'w-10 h-10 rounded-xl', icon: 'h-5 w-5' },
  md: { box: 'w-12 h-12 rounded-xl', icon: 'h-6 w-6' },
  lg: { box: 'w-16 h-16 rounded-2xl', icon: 'h-8 w-8' },
};

const VARIANTS = {
  purple: 'bg-[rgba(58,0,224,0.08)] text-[#3a00e0] border-[rgba(58,0,224,0.18)]',
  /** Orange encre #c47a0a — lisible sur blanc (pas #fab03a en body text) */
  orange: 'bg-[rgba(var(--brand-orange-rgb),0.16)] text-[var(--brand-orange-ink)] border-[rgba(var(--brand-orange-rgb),0.4)]',
  gradient:
    'bg-gradient-to-br from-[rgba(58,0,224,0.1)] to-[rgba(var(--brand-orange-rgb),0.18)] text-[#3a00e0] border-[rgba(58,0,224,0.2)]',
};

/**
 * Consistent lucide icon in a colored rounded badge.
 */
const IconBadge = ({ icon: Icon, variant = 'purple', size = 'md', className, iconClassName }) => {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.purple;

  return (
    <div
      className={cn(
        'flex items-center justify-center border shrink-0',
        s.box,
        v,
        className
      )}
    >
      <Icon className={cn(s.icon, iconClassName)} strokeWidth={1.75} aria-hidden="true" />
    </div>
  );
};

export default IconBadge;
